import { useState } from 'react';
import {
  Globe, Mail, MessageCircle, Facebook, Twitter,
  Linkedin, Instagram, Youtube, Zap, Code,
  Database, Cloud, Lock, CheckCircle, XCircle,
  RefreshCw, Plus, Settings as SettingsIcon
} from 'lucide-react';

export default function IntegrationsPage() {
  const [integrations, setIntegrations] = useState([
    { id: 1, name: 'Gmail', icon: Mail, connected: true, category: 'email' },
    { id: 2, name: 'Slack', icon: MessageCircle, connected: true, category: 'messaging' },
    { id: 3, name: 'Facebook', icon: Facebook, connected: true, category: 'social' },
    { id: 4, name: 'Twitter', icon: Twitter, connected: false, category: 'social' },
    { id: 5, name: 'LinkedIn', icon: Linkedin, connected: true, category: 'social' },
    { id: 6, name: 'Instagram', icon: Instagram, connected: false, category: 'social' },
    { id: 7, name: 'HubSpot', icon: Database, connected: false, category: 'crm' },
    { id: 8, name: 'Salesforce', icon: Cloud, connected: false, category: 'crm' }
  ]);

  const categories = ['Toutes', 'email', 'social', 'messaging', 'crm'];
  const [selectedCategory, setSelectedCategory] = useState('Toutes');

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold bg-gradient-to-r from-cyan-400 to-blue-400 bg-clip-text text-transparent">
          Intégrations
        </h1>
        <button className="px-4 py-2 bg-cyan-600 rounded-lg text-white flex items-center gap-2">
          <Plus size={18} />
          Ajouter
        </button>
      </div>

      {/* Filtres */}
      <div className="flex gap-2">
        {categories.map(cat => (
          <button
            key={cat}
            onClick={() => setSelectedCategory(cat)}
            className={`px-4 py-2 rounded-lg text-sm font-medium transition ${
              selectedCategory === cat ? 'bg-cyan-600 text-white' : 'bg-gray-900 text-gray-400 hover:text-white'
            }`}
          >
            {cat.charAt(0).toUpperCase() + cat.slice(1)}
          </button>
        ))}
      </div>

      {/* Grille des intégrations */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        {integrations
          .filter(i => selectedCategory === 'Toutes' || i.category === selectedCategory)
          .map(integration => {
            const Icon = integration.icon;
            return (
              <div key={integration.id} className="bg-gray-900 p-6 rounded-xl border border-gray-800 hover:border-cyan-500/50 transition">
                <div className="flex items-center justify-between mb-4">
                  <div className="p-3 bg-gray-800 rounded-lg">
                    <Icon size={24} className={
                      integration.name === 'Gmail' ? 'text-red-400' :
                      integration.name === 'Facebook' ? 'text-blue-500' :
                      integration.name === 'Twitter' ? 'text-sky-400' :
                      integration.name === 'LinkedIn' ? 'text-blue-600' :
                      integration.name === 'Instagram' ? 'text-pink-500' :
                      'text-gray-400'
                    } />
                  </div>
                  {integration.connected ? (
                    <CheckCircle className="text-green-400" size={20} />
                  ) : (
                    <XCircle className="text-gray-600" size={20} />
                  )}
                </div>
                <h3 className="text-white font-medium mb-1">{integration.name}</h3>
                <p className="text-sm text-gray-500 mb-4 capitalize">{integration.category}</p>
                <button className={`w-full px-4 py-2 rounded-lg text-sm font-medium transition ${
                  integration.connected
                    ? 'bg-red-500/10 text-red-400 hover:bg-red-500/20'
                    : 'bg-cyan-500/10 text-cyan-400 hover:bg-cyan-500/20'
                }`}>
                  {integration.connected ? 'Déconnecter' : 'Connecter'}
                </button>
              </div>
            );
          })}
      </div>
    </div>
  );
}